import React, { useEffect } from 'react';
import { initGA, logPageView } from "../utils/googleAnalytics.js"

import { useDispatch } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

import { signOut } from '../store/actions/AuthActions';

import Navbar from '../components/Navbar';

import { store } from '../store';

export default function RouteWrapper({
  component: Component,
  isPrivate,
  isLogout,
  accessLevel,
  ...rest
}) {
  const { signed, accessLevel: userAccessLevel } = store.getState().auth;
  const dispatch = useDispatch();
  
  useEffect(() => {
    initGA();
    logPageView();
  })

  if (isLogout) {
    dispatch(signOut());
    return <Redirect to="/" />;
  }

  if (!signed && isPrivate) {
    return <Redirect to="/" />;
  }

  if (signed && !isPrivate) {
    return <Redirect to="/patentes" />;
  }

  if (signed && accessLevel > userAccessLevel) {
    return <Redirect to="/patentes" />;
  }

  return (
    <>
      {signed && <Navbar />}
      <Route {...rest} render={props => <Component {...props} />} />
    </>
  );
}

RouteWrapper.propTypes = {
  isPrivate: PropTypes.bool,
  isLogout: PropTypes.bool,
  component: PropTypes.oneOfType([PropTypes.element, PropTypes.func])
    .isRequired,
  location: PropTypes.object,
  accessLevel: PropTypes.number
};

RouteWrapper.defaultProps = {
  isPrivate: false,
  isLogout: false
};
